import { ImageInfo } from '@/components/data/dataType';
import { create, StoreApi, UseBoundStore } from 'zustand';
import { devtools } from 'zustand/middleware';

interface EditedTextProps {
    field: string;
    sectionId: number;
    blockId?: number;
    cellId?: number;
    element: string;
    text?: string;
    image?: ImageInfo;
    dirty: boolean;
}

export interface StoreProps {
    editing: boolean;
    setEditing: (value: boolean) => void;
    editedText: EditedTextProps[];
    setEditedText: (value: EditedTextProps) => void;
    clearEditedText: () => void;
    editedLink: EditedTextProps[];
    setEditedLink: (value: EditedTextProps) => void;
    editedImage: EditedTextProps[];
    setEditedImage: (value: EditedTextProps) => void;
}

const useStore: UseBoundStore<StoreApi<StoreProps>> = create(
    devtools(set => ({
        editing: false,
        setEditing: (value: boolean) => {
            set({ editing: value });
        },
        editedText: [],
        setEditedText: (value: EditedTextProps) => {
            set(state => ({
                editedText: [
                    ...filterEditedValue(state.editedText, value),
                    value,
                ],
            }));
        },
        clearEditedText: () => {
            set({ editedText: [] });
        },
        editedLink: [],
        setEditedLink: (value: EditedTextProps) => {
            set(state => ({
                editedLink: [
                    ...filterEditedValue(state.editedLink, value),
                    value,
                ],
            }));
        },
        editedImage: [],
        setEditedImage: (value: EditedTextProps) => {
            set(state => ({
                editedImage: [
                    ...filterEditedValue(state.editedImage, value),
                    value,
                ],
            }));
        },
    })),
);

const filterEditedValue = (
    oldValue: EditedTextProps[],
    value: EditedTextProps,
) => {
    if (!oldValue) {
        return [];
    }
    const filtered =
        oldValue.filter(
            f =>
                !(
                    (f.sectionId == value.sectionId &&
                        f.field == value.field &&
                        f.element == value.element &&
                        (f.blockId || 0) == value.blockId &&
                        (f.cellId || 0) == value.cellId) ||
                    0
                ),
        ) || undefined;
    return filtered;

    return [];
};

export default useStore;
